// nextjs, react
import {
  SimpleGrid,
  Box,
  Image,
  Text,
  Flex,
  Button
} from '@chakra-ui/react'
import { useEffect, useState, Fragment } from 'react'
// Router
import { useRouter } from 'next/router'
// Redux
import { useSelector } from 'react-redux'
import { selectSite } from '../store/slice/site'
// Components
import Error from '../components/Error'
import LoadingIcon from '../components/icons/Loading'
import HotIcon from '../components/icons/Hot'
import { toast } from 'react-toastify'
// API
import { launchGameAPI } from '../utils/api'
// i18n
import { lang } from '../utils/i18n'
// css
import styles from '../styles/Card.module.scss'
import NoImg from '../images/image-not-found.png'

const Card = ({ data, hasNextPage, isFetchingNextPage, isFetching, gameListFetchNextPage }) => {
  const timestamp = Date.now()
  const state = useSelector(selectSite)
  const { query } = useRouter()
  const [errorType, setErrorType] = useState('game-not-found')
  // 漸層色
  const linearColor = () => {
    return state.theme === 'light'
      ? 'linear-gradient(rgba(255, 255, 255, 0) 0%, #fff 55%);'
      : 'linear-gradient(rgba(48, 48, 48, 0) 0%, #303030 55%);'
  }

  // 啟動遊戲
  const launchGame = async ({ game_code }) => {
    const params = {
      player_name: state.account,
      game_code,
      vendor_code: query?.vendor,
      language: state?.language || 'en'
    }

    const res = await launchGameAPI(params)

    if (res?.status === 1 && res?.data?.url) {
      window.open(res?.data?.url, '_blank', 'noopener,noreferrer')
      // webview, safari 不能跳新分頁，所以在加上標語
      toast.success(lang.launchGame[state?.language], {
        position: "top-center"
      })
    }

  }

  // 元件：Loading
  const Loading = () => {
    return (
      <Flex justify='center' align='center' mt='60px'>
        <LoadingIcon className={styles.loading} />
      </Flex>
    )
  }

  // 元件：沒有更多遊戲
  const NoMoreGame = () => {
    return (
      <Flex justify='center' align='center' mt='60px'>
        <Text fontSize='15px' fontWeight='700' color='#E8E7EA'>
          {state.language === 'zh' ? '没有更多了' : 'No More Game'}
        </Text>
      </Flex>
    )
  }

  useEffect(() => {
    // 判斷產品商是否有開放試玩
    if (Object.keys(state?.activeVendor).length !== 0 && !state?.activeVendor?.trial) {
      setErrorType('no-trial')
    } else {

      // 判斷產品商是否有新增遊戲
      data?.pages?.length === 1 && data?.pages[0]?.data.length === 0
        ? setErrorType('no-game')
        : setErrorType(null)

      // if (data?.pages?.length === 1 && data?.pages[0]?.data.length === 0) {
      //   console.log('❌❌❌❌❌❌ 沒有新增遊戲')
      // }

    }
  }, [state?.activeVendor, data?.pages?.length, data?.pages])


  return (
    <Box pos={'relative'}>
      {/* 卡片 */}
      {!errorType && (
        <SimpleGrid
          columns={{
            base: 1,
            md: 2,
            lg: 3
          }}
          spacing={{ base: '4', lg: '6' }}>
          {
            data?.pages?.map((group, i) => {
              return (
                <Fragment key={`game-${i}`}>
                  {
                    group?.data.map(item => {
                      return (
                        <Box
                          key={`game-${item.game_code}-${i}`} width="100%"
                          height={{
                            base: '240px',
                            mdd: '220px',
                            md: "220px",
                            lg: '280px', xl: '280px'
                          }}
                          overflow='hidden'
                          className={`${styles['game-card']} wow fadeInUp`}
                          cursor={'pointer'}
                          data-wow-duration='0.8s'
                          data-wow-delay="0.5s"
                          onClick={() => launchGame(item)}
                          transition={'all .3s ease'}
                        >

                          <Box
                            height={{
                              base: '201px',
                              mmd: '280px',
                              md: "192px",
                              lg: '220px',
                              xl: '240px'
                            }}
                            // className='card'
                            width="100%"
                            position='relative'
                            // _before={{
                            //   content: '""',
                            //   position: 'absolute',
                            //   top: 0,
                            //   left: 0,
                            //   width: '100%',
                            //   height: '100%',
                            //   background: 'rgba(0, 0, 0, 0.5)',  // 這裡換成你想要的背景色或其他樣式
                            //   zIndex: 0  // 這個值可以調整，根據你的需求
                            // }}
                          >
                            <Image
                              src={`${item.en_pic_url || item.zh_pic_url || 'Hazel'}`}
                              alt={`${item.name_zh} ${item.name_en} ${item.game_code}`}
                              borderRadius='lg'
                              boxShadow={'md'}
                              width='100%'
                              height='100%'
                              fallbackSrc={NoImg.src}
                              transition={'all .3s ease'}
                            />

                            {/* 系統維護中 */}
                            {/* <Box
                              className='is-maintain'
                              position='absolute'
                              top='12px'
                              left='12px'
                              borderRadius={'4px'}
                              paddingLeft={'12px'}
                              paddingRight={'12px'}
                              backgroundColor={'#c01200'}
                              borderColor={'#c01200'}
                              color={'rgba(0, 0, 0, 0.85)'}
                              zIndex={2}
                            >
                              系统维护中
                            </Box> */}

                            {/* 當 API 給 hot 表示熱門遊戲，則出現對應的 HotIcon Tag */}
                            {item.hot === 1 && (
                              <Box
                                className='hot-game'
                                position='absolute'
                                top='3px'
                                right='0'
                              >
                                <HotIcon
                                />
                              </Box>
                            )}
                          </Box>
                          <Text textAlign="center" mt="0.5rem">
                            {state?.language && state.language === 'zh'
                              ? item.name_zh
                              : item.name_en}
                          </Text>
                        </Box>
                      )
                    })
                  }

                </Fragment>
              )
            })
          }
        </SimpleGrid>
      )}


      {errorType ? (
        <Box>
          <Error type={errorType} />
        </Box>
      ) : (
        <>

          {/* loading */}
          {isFetchingNextPage && isFetching && hasNextPage
            ? (
              <Box>
                <Loading />
              </Box>
            )
            : hasNextPage && !isFetching
              ? (
                <Box>
                  {/* 遮罩 */}
                  {data?.pages?.length > 0 && hasNextPage && (
                    <Box
                      w={'100%'}
                      height={'130px'}
                      pos={'absolute'}
                      bottom={'60px'}
                      bg={linearColor()}
                    />
                  )}

                  <Button
                    mt={'1.5rem'}
                    w={'100%'}
                    onClick={gameListFetchNextPage}
                  >
                    Load More
                  </Button>
                </Box>
              )
              : (
                <>
                  <NoMoreGame />
                </>)}
        </>
      )}
    </Box>
  )
}

export default Card;